import { css } from 'emotion'

export const NewTeamFormStyles = css``
